
import { Dispatch } from "@reduxjs/toolkit";
import { RootState } from "../../../app/store";
import { TableThingyActions } from "../actions/table_actions";
import {userdata} from "../typing/table_typing";
import { myfetchThunk } from "../../../app/myfetch";
import {masteruri} from "../../../config";


interface testdataResponsePayloadInterface{
    data:{
        user:userdata[],
    }
}

export const requestDataFromAPI =() => {
    return (
        dispatch:Dispatch<any>, 
        getState:() => RootState
    )=>{       
        dispatch(myfetchThunk(
            true,
            masteruri+"/Mandants",
            {},
            "GET",
            (payload:testdataResponsePayloadInterface) => {
                console.log(payload.data)
                dispatch(
                     TableThingyActions.resetData(
                         {
                             data : payload.data.user,
                         }
                     )
                 );
            },
            ()=>{}
        ) as any)
    }
}